import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateAgentAvatar = () => {
	const [loading, setLoading] = useState(false);

	const updateAgentAvatar = async (formData) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateAgentAvatar(formData);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update agent avatar:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateAgentAvatar,
		loading,
	};
};

export default useUpdateAgentAvatar;
